import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function zone() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1,
            active: true
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`zone/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`zone/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('zone/create', data);
    }

    function update(data) {
        return axiosInstance.patch('zone/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`zone/delete`, {
            data: {
                id: id
            }
        });
    }
}
